<template>
    <div class="ls-zillow-drawer">
        <p class="ls-margin--none ls-zillow-drawer__title" :class="alignClass">
            <a
                v-ls-track.click="{
                    target: 'powered-by-zillow--link',
                }"
                class="ls-color--black"
                data-font-size="-2"
                @click.prevent="toggleDrawer()"
                >Powered by Zillow</a
            >
        </p>
        <div
            v-if="drawerOpen"
            class="ls-zillow-drawer__content ls-align--center"
            data-font-size="-2"
        >
            <p class="ls-margin--top-none">
                <a
                    v-ls-track.click="{
                        target: 'zillow--see-more-details',
                    }"
                    :href="order.zillow.link || 'https://www.zillow.com'"
                    target="_blank"
                    rel="nofollow"
                >
                    See more details for
                    <br />
                    {{ order.address.street }}
                    <br />
                    on Zillow
                </a>
            </p>
            <p>
                <a href="https://www.zillow.com/" target="_blank" rel="nofollow">
                    <img
                        src="https://www.zillow.com/widgets/GetVersionedResource.htm?path=/static/logos/Zillowlogo_150x40.gif"
                        width="150"
                        height="40"
                        alt="Zillow Real Estate Search"
                    />
                </a>
            </p>
            <p class="ls-margin--bottom-none">
                &copy; Zillow, Inc., 2006&ndash;2022.
                <br />
                Use is subject to
                <a href="https://www.zillow.com/corp/Terms.htm" target="_blank" rel="nofollow"
                    >Terms of Use</a
                >
            </p>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'LsZillowDrawer',
    props: {
        alignClass: { type: String, default: 'ls-align--right' },
    },
    data() {
        return {
            drawerOpen: false,
        };
    },
    computed: {
        ...mapState(['order']),
    },
    methods: {
        toggleDrawer() {
            this.drawerOpen = !this.drawerOpen;
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-zillow-drawer__title {
    padding: rem(-4);
    background-color: palette(gray, xx-light);
    font-weight: 700;
    &:hover {
        text-decoration: underline;
    }
}

.ls-zillow-drawer__content {
    padding: rem(-4) 0;
    background-color: palette(white);
    border-bottom: 1px solid palette(gray, xx-light);
}
.themed-app {
    .ls-zillow-drawer__title {
        background-color: $theme-color-gray-light;
    }
    .ls-zillow-drawer__content {
        background-color: $theme-color-white;
        border-bottom: 1px solid $theme-color-gray-light;
    }
}
</style>
